import { LowerCasePipe, TitleCasePipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { TicketSummaryDto } from '@workspace/data-types';
import {
  AvatarAuraComponent,
  BaseDataTableCoreComponent,
  DataTableComponent,
  LuxonDatePipe,
  SimpleChipComponent,
} from '@workspace/ng-aura';
import { TicketColumnKey } from './abstract-tickets-data-table.component';
import { TicketsDataTableFilterCoreComponent } from './filter/tickets-data-table-filter.component';

@Component({
  selector: 'core-tickets-data-table',
  templateUrl: './tickets-data-table.component.html',
  imports: [
    DataTableComponent,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatCellDef,
    MatCell,
    LuxonDatePipe,
    TitleCasePipe,
    LowerCasePipe,
    MatIconModule,
    MatTooltipModule,
    AvatarAuraComponent,
    RouterModule,
    MatButton,
    SimpleChipComponent,
    TicketsDataTableFilterCoreComponent,
  ],
})
export class TicketsDataTableCoreComponent extends BaseDataTableCoreComponent<
  TicketSummaryDto,
  TicketColumnKey
> {}
